/**
 * Created by Ning Jiang on 11/23/2016.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {SpinMode} from "@nolimitcity/slot-game/bin/core/gametype/SpinMode";
import {IStackedReelSymbolsConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {LayerScaleOption} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IWinRatios, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Back, Ease} from "gsap";
import {IWildNudgeSymbolStates} from "./reelsymbol/WildNudgeReelSymbol";
import {IWildNudgeLayerConfig} from "./stage/IWildNudgeLayerConfig";

export class WildNudgeGameConfig implements IGameConfig {

    public static instance:WildNudgeGameConfig = new WildNudgeGameConfig();

    BROWSER_FPS:number = 30;

    GAME_WIDTH:number = 1280;
    GAME_HEIGHT:number = 720;

    DEFAULT_LAYER_SCALE_OPTION:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {landscape : LayerScaleOption.FIT_WINDOW},
        mobile : {
            landscape : LayerScaleOption.FIT_WINDOW,
            portrait : LayerScaleOption.REELS_FIT_WINDOW
        }
    };

    LAYERS:IWildNudgeLayerConfig = {
        BACKGROUND : {name : "background"},
        BACKGROUND_STEAM : {name : "backgroundSteam"},
        SPOT_LIGHTS : {name : "spotLights"},
        REEL_BACKGROUND : {name : "reelBackground"},
        FREESPINS_LEFT : {name : "freespinsLeft"},
        MULTIPLIER : {name : "multiplier"},
        SYMBOLS : {name : "symbols"},
        FOREGROUND : {name : "foreground"},
        FORGROUND_ANIMATIONS : {name : "forgroundAnimations"},
        FREESPINS_LIDS : {name : "freespinLids"},
        FEATURE_INDICATOR : {name : "featureIndicator"},
        REEL_ATTENTION : {name : "reelAttention"},
        RED_OVERLAY : {name : "redOverlay"},
        WIN_TEXTS : {name: "winTexts"},
        WIN_PRESENTATIONS : {name : "winPresentations"},
        BIG_WIN : {name : "bigWin"},
        WIN_COUNT_UP : {name : "winCountUp"},
        POP_NUMBERS : {name : "popNumbers"},
        FREESPIN_INTRO : {name : "freespinIntro"},
        FREESPIN_OUTRO : {name : "freespinOutro"},
        INTRO_BG : {name : "introBackground"},
        INTRO : {name : "introScreen", scaleOption : LayerScaleOption.FIT_WINDOW},
        TWEAK_MODULE : {name : "tweakModule"}
    };

    BET_WIN_MODE:BetWinMode = BetWinMode.BET_LINE;
    SPIN_MODE:SpinMode = SpinMode.SPIN;

    REEL_AREA_POS_X:number = 213;
    REEL_AREA_POS_Y:number = 90;
    REEL_AREA_WIDTH:number = 860;
    REEL_AREA_HEIGHT:number = 512;

    REEL_AREA_MASK_RECT:PIXI.Rectangle = new PIXI.Rectangle(263, 90, 760, 512);

    REELS_NUM:number = 5;
    REEL_DISPLAY_POSITIONS:[number, number][] = [[120, 0], [275, 0], [430, 0], [585, 0], [740, 0]];
    SYMBOLS_NUM_IN_REEL:[number, number, number, number, number] = [3, 1, 4, 1, 0];

    SYMBOL_STATES:IWildNudgeSymbolStates = {
        normal : {
            prio : 0,
            keyword : "normal"
        },
        spin : {
            prio : 1,
            keyword : "spin"
        },
        noWin : {
            prio : 2,
            keyword : "noWin",
            texturesCreator : (symName:string, stateKey:string) => {
                return GameResources.getTextures(`${symName}_normal`).slice(0, 1);
            }
        },
        hidden : {
            prio : 3,
            keyword : "hidden"
        },
        attention : {
            prio : 4,
            keyword : "attention",
            texturesCreator : (symName:string, stateKey:string) => {
                return GameResources.getTextures(`${symName}_normal`).slice(0, 1);
            }
        },
        win : {
            prio : 5,
            keyword : "win"
        }
    };
    SYMBOL_WIDTH:number = 140;
    SYMBOL_HEIGHT:number = 128;
    SYMBOL_BOTTOM_PADDING:number = 0;
    STACKED_SYMBOLS:IStackedReelSymbolsConfig = {
        "W" : {
            totalNum : 4,
            reels : [1, 2, 3]
        },
        "M1" : {
            totalNum : 4
        },
        "M2" : {
            totalNum : 4
        },
        "M3" : {
            totalNum : 4
        }
    };

    REEL_SPIN_TIME:number = 0.9;
    REEL_FAST_SPIN_SPIN_TIME:number = 0.1;
    MIN_STOPPING_TIME:number = 2;

    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DELAY:number = 0.3;
    REEL_SPIN_START_EASE:Ease = Back.easeIn.config(4);
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY:number = 0;
    REEL_SPIN_STOP_ELASTIC_CONFIG:[number, number] = [1.5, 0.95];
    REEL_SPIN_QUICK_STOP_ELASTIC_CONFIG:[number, number] = [1.2, 0.75];

    REEL_SPIN_START_SPEED:number = 0.3;
    REEL_SPIN_SPIN_SPEED:number = 0.04;
    REEL_NEAR_WIN_SPIN_SPEED:number = 0.03;
    REEL_SPIN_STOP_SPEED:number = 0.5;
    REEL_SPIN_QUICK_STOP_SPEED:number = 0.5;

    REEL_STOP_DELAY:number = 0.3;
    REEL_QUICK_STOP_DELAY:number = 0.1;
    REEL_NEAR_WIN_STOP_DELAY:number[] = [4, 4, 4, 5, 6];

    REEL_SETS:any = {
        "BASE_REELSET" : [
            ["M1", "M1", "M1", "M1", "L4", "L4", "L1", "L1", "L2", "L2", "L4", "L4", "L1", "L1", "M3", "M3", "M3", "M3", "L1", "L1", "L4", "L4", "M2", "M2", "M2", "M2", "L4", "L4", "L1", "L1", "M3", "M3", "M3", "M3", "L1", "L1", "L4", "L4", "L1", "L1", "L3", "L3", "M3", "M3", "M3", "M3", "L4", "L4", "L1", "L1", "L2", "L2", "L3", "L3", "L4", "L4", "L1", "L1", "L3", "L3", "L4", "L4", "M1", "M1", "M1", "M1", "L1", "L1", "L4", "L4", "L3", "L3", "L2", "L2", "L1", "L1", "L4", "L4", "L3", "L3"],
            ["M3", "M3", "M3", "M3", "L2", "L2", "L4", "L4", "S", "L3", "L3", "M1", "M1", "M1", "M1", "L4", "L4", "L2", "L2", "L1", "L1", "M3", "M3", "M3", "M3", "S", "L2", "L2", "L4", "L4", "M2", "M2", "M2", "M2", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L3", "L3", "L2", "L2", "S", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "L3", "L3", "L4", "L4", "S", "L2", "L2", "M3", "M3", "M3", "M3", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "L2", "L2", "L4", "L4", "W", "W", "W", "W", "L3", "L3", "L2", "L2", "M2", "M2", "M2", "M2", "L3", "L3", "L4", "L4", "L2", "L2", "L1", "L1", "L3", "L3", "S", "M3", "M3", "M3", "M3", "L4", "L4", "L2", "L2", "S", "M3", "M3", "M3", "M3", "L2", "L2", "L4", "L4", "L3", "L3", "M1", "M1", "M1", "M1", "L4", "L4", "S", "L2", "L2", "L1", "L1", "M3", "M3", "M3", "M3", "L2", "L2", "L4", "L4", "S", "M2", "M2", "M2", "M2", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L3", "L3", "L2", "L2", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "L3", "L3", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "L2", "L2", "L4", "L4"],
            ["M1", "M1", "M1", "M1", "L3", "L3", "S", "L2", "L2", "L1", "L1", "L3", "L3", "M2", "M2", "M2", "M2", "L2", "L2", "L3", "L3", "M1", "M1", "M1", "M1", "L3", "L3", "L2", "L2", "L4", "L4", "S", "M3", "M3", "M3", "M3", "L1", "L1", "L3", "L3", "L2", "L2", "M2", "M2", "M2", "M2", "L3", "L3", "L2", "L2", "L1", "L1", "L3", "L3", "L2", "L2", "M1", "M1", "M1", "M1", "L2", "L2", "L3", "L3", "L4", "L4", "S", "L2", "L2", "M2", "M2", "M2", "M2", "L3", "L3", "L1", "L1", "W", "W", "W", "W", "L2", "L2", "L4", "L4", "L3", "L3", "L2", "L2", "M3", "M3", "M3", "M3", "L2", "L2", "L4", "L4", "S", "L3", "L3", "M1", "M1", "M1", "M1", "L4", "L4", "L2", "L2", "L1", "L1", "M3", "M3", "M3", "M3", "L2", "L2", "L4", "L4", "M2", "M2", "M2", "M2", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L3", "L3", "L2", "L2", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "S", "L3", "L3", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "L2", "L2", "L4", "L4", "L3", "L3", "S", "L2", "L2", "M2", "M2", "M2", "M2", "L4", "L4", "L2", "L2", "L1", "L1", "L3", "L3", "M3", "M3", "M3", "M3", "L4", "L4", "L2", "L2"],
            ["M1", "M1", "M1", "M1", "L1", "L1", "S", "L4", "L4", "L3", "L3", "M3", "M3", "M3", "M3", "L2", "L2", "L1", "L1", "L3", "L3", "M2", "M2", "M2", "M2", "L4", "L4", "S", "L3", "L3", "L1", "L1", "L4", "L4", "M2", "M2", "M2", "M2", "L2", "L2", "L3", "L3", "S", "M1", "M1", "M1", "M1", "L3", "L3", "L1", "L1", "L2", "L2", "S", "M1", "M1", "M1", "M1", "L1", "L1", "L4", "L4", "L3", "L3", "M3", "M3", "M3", "M3", "S", "L2", "L2", "L1", "L1", "L3", "L3", "M2", "M2", "M2", "M2", "L4", "L4", "S", "L3", "L3", "L1", "L1", "L4", "L4", "M2", "M2", "M2", "M2", "L2", "L2", "L3", "L3", "S", "M1", "M1", "M1", "M1", "L3", "L3", "L1", "L1", "L2", "L2", "M1", "M1", "M1", "M1", "L1", "L1", "L4", "L4", "S", "L3", "L3", "M3", "M3", "M3", "M3", "L2", "L2", "L1", "L1", "L3", "L3", "S", "M2", "M2", "M2", "M2", "L4", "L4", "L3", "L3", "L1", "L1", "L4", "L4", "S", "M2", "M2", "M2", "M2", "L2", "L2", "L3", "L3", "S", "M1", "M1", "M1", "M1", "L3", "L3", "L1", "L1", "L2", "L2", "S", "M1", "M1", "M1", "M1", "L1", "L1", "L4", "L4", "W", "W", "W", "W", "L3", "L3", "M3", "M3", "M3", "M3", "L2", "L2", "L1", "L1", "S", "L3", "L3", "M2", "M2", "M2", "M2", "L4", "L4", "L3", "L3", "L1", "L1", "S", "L4", "L4", "M2", "M2", "M2", "M2", "L2", "L2", "L3", "L3", "S", "M1", "M1", "M1", "M1", "L3", "L3", "L1", "L1", "L2", "L2", "M1", "M1", "M1", "M1", "L1", "L1", "S", "L4", "L4", "L3", "L3", "M3", "M3", "M3", "M3", "L2", "L2", "L1", "L1", "L3", "L3", "S", "M2", "M2", "M2", "M2", "L4", "L4", "L3", "L3", "L1", "L1", "L4", "L4", "S", "M2", "M2", "M2", "M2", "L2", "L2", "L3", "L3", "M1", "M1", "M1", "M1", "L3", "L3", "L1", "L1", "S", "L2", "L2"],
            ["M1", "M1", "M1", "M1", "L4", "L4", "L3", "L3", "M3", "M3", "M3", "M3", "L2", "L2", "L1", "L1", "M2", "M2", "M2", "M2", "L4", "L4", "L1", "L1", "L2", "L2", "L3", "L3"]
        ],
        "FREESPIN_REELSET" : [
            ["M1", "M1", "M1", "M1", "L4", "L4", "L1", "L1", "L2", "L2", "L4", "L4", "L1", "L1", "M3", "M3", "M3", "M3", "L1", "L1", "L4", "L4", "M2", "M2", "M2", "M2", "L4", "L4", "L1", "L1", "M3", "M3", "M3", "M3", "L1", "L1", "L4", "L4", "L1", "L1", "L3", "L3", "M3", "M3", "M3", "M3", "L4", "L4", "L1", "L1", "L2", "L2", "L3", "L3", "L4", "L4", "L1", "L1", "L3", "L3", "L4", "L4", "M1", "M1", "M1", "M1", "L1", "L1", "L4", "L4", "L3", "L3", "L2", "L2", "L1", "L1", "L4", "L4", "L3", "L3"],
            ["M3", "M3", "M3", "M3", "W", "W", "W", "W", "L2", "L2", "L4", "L4", "L3", "L3", "M1", "M1", "M1", "M1", "L4", "L4", "L2", "L2", "L1", "L1", "M3", "M3", "M3", "M3", "S", "L2", "L2", "L4", "L4", "M2", "M2", "M2", "M2", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L3", "L3", "L2", "L2", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "L3", "L3", "L4", "L4", "S", "L2", "L2", "M3", "M3", "M3", "M3", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "L2", "L2", "L4", "L4", "W", "W", "W", "W", "L3", "L3", "L2", "L2", "M2", "M2", "M2", "M2", "L3", "L3", "S", "L4", "L4", "L2", "L2", "L1", "L1", "L3", "L3", "M3", "M3", "M3", "M3", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L2", "L2", "L4", "L4", "L3", "L3", "M1", "M1", "M1", "M1", "L4", "L4", "L2", "L2", "L1", "L1", "M3", "M3", "M3", "M3", "L2", "L2", "L4", "L4", "S", "M2", "M2", "M2", "M2", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L3", "L3", "L2", "L2", "L4", "L4", "L1", "L1", "W", "W", "W", "W", "M2", "M2", "M2", "M2", "L3", "L3", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "L2", "L2", "L4", "L4"],
            ["M1", "M1", "M1", "M1", "L3", "L3", "S", "L2", "L2", "L1", "L1", "L3", "L3", "M2", "M2", "M2", "M2", "L2", "L2", "L3", "L3", "M1", "M1", "M1", "M1", "L3", "L3", "L2", "L2", "L4", "L4", "M3", "M3", "M3", "M3", "L1", "L1", "L3", "L3", "L2", "L2", "M2", "M2", "M2", "M2", "L3", "L3", "L2", "L2", "L1", "L1", "L3", "L3", "L2", "L2", "M1", "M1", "M1", "M1", "L2", "L2", "L3", "L3", "L4", "L4", "S", "L2", "L2", "M2", "M2", "M2", "M2", "L3", "L3", "L1", "L1", "W", "W", "W", "W", "L2", "L2", "L4", "L4", "L3", "L3", "L2", "L2", "M3", "M3", "M3", "M3", "L2", "L2", "L4", "L4", "L3", "L3", "W", "W", "W", "W", "M1", "M1", "M1", "M1", "L4", "L4", "L2", "L2", "L1", "L1", "M3", "M3", "M3", "M3", "L2", "L2", "L4", "L4", "M2", "M2", "M2", "M2", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L3", "L3", "L2", "L2", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "L3", "L3", "L4", "L4", "L2", "L2", "M3", "M3", "M3", "M3", "L4", "L4", "L1", "L1", "M2", "M2", "M2", "M2", "L2", "L2", "L4", "L4", "L3", "L3", "S", "L2", "L2", "M2", "M2", "M2", "M2", "L4", "L4", "L2", "L2", "L1", "L1", "L3", "L3", "M3", "M3", "M3", "M3", "L4", "L4", "L2", "L2"],
            ["M1", "M1", "M1", "M1", "L1", "L1", "S", "L4", "L4", "L3", "L3", "M3", "M3", "M3", "M3", "L2", "L2", "L1", "L1", "L3", "L3", "M2", "M2", "M2", "M2", "L4", "L4", "L3", "L3", "L1", "L1", "L4", "L4", "M2", "M2", "M2", "M2", "L2", "L2", "L3", "L3", "S", "M1", "M1", "M1", "M1", "L3", "L3", "L1", "L1", "L2", "L2", "M1", "M1", "M1", "M1", "L1", "L1", "L4", "L4", "L3", "L3", "M3", "M3", "M3", "M3", "L2", "L2", "L1", "L1", "L3", "L3", "M2", "M2", "M2", "M2", "L4", "L4", "S", "L3", "L3", "L1", "L1", "L4", "L4", "M2", "M2", "M2", "M2", "W", "W", "W", "W", "L2", "L2", "L3", "L3", "M1", "M1", "M1", "M1", "L3", "L3", "L1", "L1", "L2", "L2", "M1", "M1", "M1", "M1", "L1", "L1", "L4", "L4", "L3", "L3", "M3", "M3", "M3", "M3", "L2", "L2", "L1", "L1", "L3", "L3", "S", "M2", "M2", "M2", "M2", "L4", "L4", "L3", "L3", "L1", "L1", "L4", "L4", "M2", "M2", "M2", "M2", "L2", "L2", "L3", "L3", "M1", "M1", "M1", "M1", "L3", "L3", "L1", "L1", "L2", "L2", "M1", "M1", "M1", "M1", "L1", "L1", "L4", "L4", "W", "W", "W", "W", "L3", "L3", "M3", "M3", "M3", "M3", "L2", "L2", "L1", "L1", "L3", "L3", "M2", "M2", "M2", "M2", "L4", "L4", "L3", "L3", "L1", "L1", "L4", "L4", "M2", "M2", "M2", "M2", "L2", "L2", "L3", "L3", "S", "M1", "M1", "M1", "M1", "L3", "L3", "L1", "L1", "L2", "L2"],
            ["M1", "M1", "M1", "M1", "L4", "L4", "L3", "L3", "M3", "M3", "M3", "M3", "L2", "L2", "L1", "L1", "M2", "M2", "M2", "M2", "L4", "L4", "L1", "L1", "L2", "L2", "L3", "L3"]
        ],
        "STACKED_SPIN_REELSET" : [
            ["X", "X", "X", "X"],
            ["X", "X", "X", "X"],
            ["L2", "L2", "L1", "L1", "X", "X", "X", "X", "L4", "L4", "L1", "L1", "L3", "L3", "L2", "L2", "L1", "L1", "L4", "L4", "L1", "L1", "X", "X", "X", "X", "L2", "L2", "L4", "L4", "L3", "L3", "L1", "L1", "L2", "L2", "L1", "L1", "L4", "L4", "X", "X", "X", "X", "L1", "L1", "L2", "L2", "L3", "L3", "L1", "L1", "L4", "L4", "L3", "L3", "L2", "L2", "X", "X", "X", "X", "L4", "L4", "L1", "L1", "L3", "L3", "L4", "L4", "L1", "L1", "L2", "L2", "L3", "L3", "W", "W", "W", "W", "L1", "L1", "L2", "L2", "L1", "L1", "L4", "L4", "L3", "L3"],
            ["X", "X", "X", "X", "L2", "L2", "L1", "L1", "L3", "L3", "L4", "L4", "L1", "L1", "L2", "L2", "L4", "L4", "L1", "L1", "L3", "L3", "L2", "L2", "L4", "L4", "L1", "L1", "X", "X", "X", "X", "L1", "L1", "L2", "L2", "L4", "L4", "L1", "L1", "L2", "L2", "L3", "L3", "L4", "L4", "L2", "L2", "L1", "L1", "L4", "L4", "L3", "L3", "L1", "L1", "X", "X", "X", "X", "L2", "L2", "L1", "L1", "L4", "L4", "L2", "L2", "L3", "L3", "L1", "L1", "L3", "L3", "L2", "L2", "L4", "L4", "L1", "L1", "L2", "L2", "L3", "L3", "X", "X", "X", "X", "L3", "L3", "L4", "L4", "L1", "L1", "L2", "L2", "L3", "L3", "L1", "L1", "L2", "L2", "L4", "L4", "L1", "L1", "L2", "L2", "L3", "L3", "L4", "L4", "X", "X", "X", "X", "L1", "L1", "L3", "L3", "L2", "L2", "L4", "L4", "L3", "L3", "L1", "L1", "L4", "L4", "L2", "L2", "L3", "L3", "L1", "L1", "L4", "L4", "L3", "L3", "W", "W", "W", "W", "L1", "L1", "L2", "L2", "L4", "L4", "L3", "L3", "L1", "L1", "L4", "L4", "L2", "L2", "L1", "L1", "L3", "L3", "L2", "L2", "L4", "L4", "L1", "L1"],
            ["X", "X", "X", "X", "L4", "L4", "L1", "L1", "L2", "L2", "L4", "L4", "L1", "L1", "L3", "L3", "L2", "L2", "L4", "L4", "L3", "L3", "L1", "L1", "L2", "L2", "L3", "L3", "X", "X", "X", "X", "L2", "L2", "L1", "L1", "L3", "L3", "L4", "L4", "L1", "L1", "L3", "L3", "L2", "L2", "L4", "L4", "L3", "L3", "L1", "L1", "L2", "L2", "L1", "L1", "X", "X", "X", "X", "L3", "L3", "L1", "L1", "L2", "L2", "L4", "L4", "L1", "L1", "L3", "L3", "L2", "L2", "L4", "L4", "L3", "L3", "L1", "L1", "L2", "L2", "L3", "L3"]
        ]
    };

    WIN_RATIOS:IWinRatios = {
        normalWin : [
            {
                ratio : 0,
                text : "Tiny Win",
                duration : 0.01,
                type : WinRatioType.TINY
            },
            {
                ratio : 1.5,
                text : "Small Win",
                duration : 1.061,
                type : WinRatioType.SMALL
            },
            {
                ratio : 3,
                text : "Medium Win",
                duration : 1.592,
                type : WinRatioType.MEDIUM
            },
            {
                ratio : 5,
                text : "Large Win",
                duration : 2.123,
                type : WinRatioType.LARGE
            }
        ],
        bigWin : [
            {
                ratio : 15,
                text : "Blazing",
                duration : 3.982,
                type : WinRatioType.BIG_WIN
            },
            {
                ratio : 25,
                text : "Scorching",
                duration : 3.840,
                type : WinRatioType.MEGA_WIN
            },
            {
                ratio : 50,
                text : "Atomic",
                duration : 3.8,
                type : WinRatioType.SUPER_MEGA_WIN
            }
        ]
    };

    PERFORMANCE_LOGGER:boolean = true;

    // GAME_TWEAKER_CONFIG:IGameTweakerConfig = {
    //     layer : this.LAYERS.TWEAK_MODULE.name,
    //     baseWindowWidth : 300,
    //     moduleHeight : 28,
    //     copyAllButtonText : "Copy All",
    //     buttonSkinIdle : "button",
    //     buttonSkinOver : "button",
    //     buttonSkinDown : "button",
    //     buttonSkinDisabled : "button-disabled"
    // };

    private constructor() {
        if(WildNudgeGameConfig.instance) {
            throw new Error("WildNudgeGameConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}